"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QueryModeSchema = void 0;
const zod_1 = require("zod");
exports.QueryModeSchema = zod_1.z.enum(['default', 'insensitive']);
exports.default = exports.QueryModeSchema;
//# sourceMappingURL=QueryModeSchema.js.map